export default __webpack_public_path__ + "static/media/CreateAccount.fba438bc.png";